import { render, staticRenderFns } from "./BairroCard.vue?vue&type=template&id=65c2d113&scoped=true"
import script from "./BairroCard.vue?vue&type=script&lang=js"
export * from "./BairroCard.vue?vue&type=script&lang=js"
import style0 from "./BairroCard.vue?vue&type=style&index=0&id=65c2d113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2d113",
  null
  
)

export default component.exports